import commonMixin from '../../mixins/_common';

const SORT_ARROW_ASC = 'asc';
const SORT_ARROW_DESC = 'desc';

/**
 * 商品のソート矢印
 */
export default {
    name: 'itemSortArrow',
    template: '#item_sort_arrow_component_template',
    data() {
        return {
            sort_arrow: ''
        };
    },
    props: {
        // ソートキー
        sort_key: {
            type: String,
        },
    },
    mixins: [
        commonMixin,
    ],
    computed: {
        isSortArrowAsc: function () {
            return this.sort_arrow == SORT_ARROW_ASC;
        },
        isSortArrowDesc: function () {
            return this.sort_arrow == SORT_ARROW_DESC;
        }
    },
    emits: ['click-sort'],
    methods: {
        // 矢印の向きを初期化
        initSortArrow: function () {
            this.sort_arrow = '';
        },
        // 矢印をクリックした際の処理
        clickSortArrow: function () {
            this.$_loading();

            let isAsc = this.sort_arrow === SORT_ARROW_ASC;
            let sort = '';
            if (!isAsc) {
                sort = '+' + this.sort_key;
            } else {
                sort = '-' + this.sort_key;
            }
            this.$emit('click-sort', sort);

            // 現在のソートと逆向きに変更
            this.sort_arrow = isAsc ? SORT_ARROW_DESC : SORT_ARROW_ASC;

            this.$_unloading();
        }
    }
};